module.exports = new __parcel__URL__("toto.13114708.jpg").toString();